module.exports = __webpack_public_path__ + "static/media/pw.cd9aa05c.svg";